import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { ArrowCircleRightSharp } from "@mui/icons-material";
import { MobiOrNotContext, UserContext } from "../../ContextApi/context";
import utilsCredits from "../../_Utils/utilsCredits";
import PopUpClearComp from "../../DTechComp/PopUpClearComp";
import { isNativeApp } from "../../myFunctions";
import "./MyProfile.css";


const maskEmail = (email = "") => {
    const [local, domain] = email.split("@");
    if (!domain) return email;
    return local.slice(0, 3) + "***@" + domain;
};

const maskPhone = (phone = "") => {
    if (!phone) return "";
    return <span className="big">{phone.slice(-2).toString() + "******" + "-" + phone.slice(0, 3).toString()}</span>;
};

const formatMemberSince = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    return d.toLocaleDateString("he-IL", { month: "long", year: "numeric" });
};

const formatLogDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    return d.toLocaleDateString("he-IL") + " " + d.toLocaleTimeString("he-IL", { hour: "2-digit", minute: "2-digit" });
};

const formatShortDate = (dateStr) => {
    if (!dateStr) return "";
    return new Date(dateStr).toLocaleDateString("he-IL");
};

const discountLabel = (kopon) => {
    if (!kopon.discountAmount) return "";
    if (kopon.discountType === "percent") return `${kopon.discountAmount}% הנחה`;
    return `${kopon.discountAmount} ₪ הנחה`;
};


const MyProfile = (props) => {

    const [user, setUser, UserEffectFunction] = useContext(UserContext);
    const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
    const [credits, setCredits] = useState(0);
    const [showCreditsLog, setShowCreditsLog] = useState(false);
    const [creditsLog, setCreditsLog] = useState([]);
    const [logLoading, setLogLoading] = useState(false);
    const [visibleCount, setVisibleCount] = useState(10);
    const [showCouponsPopup, setShowCouponsPopup] = useState(false);
    const [copiedKopon, setCopiedKopon] = useState(null);
    const history = useHistory();

    const copyKoponCode = (code) => {
        navigator.clipboard.writeText(code).then(() => {
            setCopiedKopon(code);
            setTimeout(() => setCopiedKopon(null), 1800);
        });
    };

    useEffect(() => {
        UserEffectFunction();
    }, []);

    useEffect(() => {
        if (user != null && user._id != null) {
            props.scrollToTop();
            props.shoTopStrp(false);
            loadData();
        } else if (user != null) {
            history.push("./");
        }
    }, [user]);

    const loadData = async () => {
        const creditsData = await utilsCredits.getMyCredits(localStorage.getItem("usrtoken"));
        if (!creditsData?.errMsg) {
            setCredits(creditsData?.credits ?? 0);
        }
    };

    const openCreditsLog = async () => {
        setShowCreditsLog(true);
        setLogLoading(true);
        setVisibleCount(10);
        const data = await utilsCredits.getMyCreditsLog();
        const sorted = [...(Array.isArray(data) ? data : [])].sort((a, b) => new Date(b.date) - new Date(a.date));
        let runningBalance = credits;
        const logWithBalances = sorted.map(entry => {
            const balanceAfter = runningBalance;
            const balanceBefore = runningBalance - entry.amount;
            runningBalance = balanceBefore;
            return { ...entry, balanceBefore, balanceAfter };
        });
        setCreditsLog(logWithBalances);
        setLogLoading(false);
    };

    const logOut = () => {
        localStorage.removeItem("usrtoken");
        setUser();
        history.push("/");
    };

    const goToAPPS = () => {
        history.push("/apps");
    }

    const allCoupons = user?.assignedKopons ?? [];

    const isStaleKopon = (k) => {
        if (k.isUsed) return true;
        if (!k.expirationDate) return false;
        const cutoff = new Date(k.expirationDate);
        cutoff.setDate(cutoff.getDate() + 30);
        return cutoff < new Date();
    };

    const visibleCoupons = allCoupons.filter(k => !isStaleKopon(k));
    const activeCoupons = visibleCoupons.filter(k => !k.expirationDate || new Date(k.expirationDate) >= new Date());

    return (
        <div className={"loginPage"}>
            <div className={"headOnFixC2 centerText bold big"}>
                פרטי לקוח
                <div className={"backSdOnlyBtn"}>
                    <ArrowCircleRightSharp onClick={() => history.goBack()} />
                </div>
            </div>
            <br /><br /><br />

            <div className={"profilePage"}>
                <div className={`profileScreen ${!mobiOrNot ? "spaceMargTopBig" : ""}`}>

                    <div className={"profileHeader"}>
                        <p className={"profileHeaderName"}>
                            {user?.firstName} {user?.lastName}
                        </p>
                        <p className={"profileHeaderMeta"}>
                            {/* {user?.dateCreated ? `משתמש מאז ${formatMemberSince(user.dateCreated)}` : ""} */}
                            {/* {user?.dateCreated && user?.email ? " · " : ""} */}
                            {user?.email ? user.email : ""}
                            <br />
                            {/* {user?.phone ? maskPhone(user.phone) : ""} */}
                        </p>
                    </div>

                    {isNativeApp() && credits > 0 && (
                        <div className={"profileCreditsCard pointing"} onClick={openCreditsLog}>
                            <p className={"profileCreditsAmount"}>
                                {credits} <span>קרדיטים</span>
                            </p>
                            <p className={"profileCreditsHint"}>לחץ לצפייה בהיסטוריה</p>
                        </div>
                    )}

                    <div className={"profileMenuList"}>

                        <div className={"profileMenuItem"} onClick={() => history.push("/MyOrders")}>
                            <div className={"profileMenuIcon profileMenuIcon--green"}>🛍️</div>
                            <div className={"profileMenuText"}>
                                <p className={"profileMenuTitle"}>ההזמנות שלי</p>
                            </div>
                            <span className={"profileMenuArrow"}>›</span>
                        </div>

                        <div className={"profileMenuItem"} onClick={() => history.push("/MyDetails")}>
                            <div className={"profileMenuIcon profileMenuIcon--gray"}>⚙️</div>
                            <div className={"profileMenuText"}>
                                <p className={"profileMenuTitle"}>הגדרות חשבון</p>
                                <p className={"profileMenuSubtitle"}>סיסמה, פרטים אישיים, אמצעי תשלום</p>
                            </div>
                            <span className={"profileMenuArrow"}>›</span>
                        </div>

                        <div className={"profileMenuItem" + (isNativeApp() ? "" : " profileMenuItem--disabled")}
                            onClick={isNativeApp() ? () => setShowCouponsPopup(true) : undefined}>
                            <div className={"profileMenuIcon profileMenuIcon--purple"}>🎟️</div>
                            <div className={"profileMenuText"}>
                                <p className={"profileMenuTitle"}>
                                    הקופונים שלי {isNativeApp() ? "" : "(באפליקציה בלבד)"}
                                    {activeCoupons.length > 0 && (
                                        <span className={"profileCouponBadge profileCouponBadge--visible"}>
                                            {activeCoupons.length}
                                        </span>
                                    )}
                                </p>
                                <p className={"profileMenuSubtitle"}>
                                    {activeCoupons.length > 0
                                        ? `${activeCoupons.length} קופונים פעילים`
                                        : "אין קופונים פעילים"}
                                </p>
                            </div>
                            <span className={"profileMenuArrow"}>›</span>
                        </div>

                        <div className={"profileMenuItem" + (isNativeApp() ? "" : " profileMenuItem--disabled")}
                            onClick={isNativeApp() ? openCreditsLog : undefined}>
                            <div className={"profileMenuIcon profileMenuIcon--yellow"}>⭐</div>
                            <div className={"profileMenuText"}>
                                <p className={"profileMenuTitle"}>הקרדיטים שלי {isNativeApp() ? "" : "(באפליקציה בלבד)"}</p>
                                <p className={"profileMenuSubtitle"}>{credits} קרדיטים זמינים</p>
                            </div>
                            <span className={"profileMenuArrow"}>›</span>
                        </div>

                        {!isNativeApp() && (
                            <div className={"profileFooter"}>
                                <button className={"profileAPPSBtn"} onClick={goToAPPS}>
                                    הורד את האפליקציה
                                </button>
                            </div>
                        )}


                    </div>

                    <div className={"profileFooter"}>
                        <button className={"profileLogoutBtn"} onClick={logOut}>
                            התנתקות מהחשבון
                        </button>
                    </div>

                </div>
            </div>

            {showCreditsLog && (
                <PopUpClearComp
                    popFullComp={"specialPopComp onTopOfAll"}
                    cssStyl={"noPadding"}
                    closePop={() => setShowCreditsLog(false)}
                    insideCss={"noPadding"}
                    theInsideComp={
                        <div className={"creditsLogPopup"}>
                            <div className={"cardsPopupHeader"}>
                                <span className={"cardsPopupTitle"}>היסטוריית קרדיטים</span>
                                <button className={"cardsPopupClose"} onClick={() => setShowCreditsLog(false)}>✕</button>
                            </div>
                            <div className={"creditsLogTotal"}>
                                <span className={"creditsLogTotalLabel"}>יתרה נוכחית</span>
                                <span className={"creditsLogTotalAmt"}>{credits}</span>
                            </div>
                            {logLoading ? (
                                <p className={"cardsPopupEmpty"}>טוען...</p>
                            ) : creditsLog.length === 0 ? (
                                <p className={"cardsPopupEmpty"}>אין פעולות קרדיטים</p>
                            ) : (
                                <div className={"creditsLogList"}>
                                    {creditsLog.slice(0, visibleCount).map((entry, i) => (
                                        <div key={i} className={"creditsLogCard"}>
                                            <div className={"creditsLogCardHeader"}>
                                                <div className={"creditsLogCardHeaderRight"}>
                                                    <span className={"creditsLogCardType rightText"}>
                                                        {entry.type === "added" ? "נוסף" : entry.type === "used" ? "נוצל" : "הוחזר"}
                                                    </span>
                                                    <span className={"creditsLogCardDate rightText"}>{formatLogDate(entry.date)}</span>
                                                    {(entry.description || entry.orderNum) && (
                                                        <span className={"creditsLogCardNote rightText"}>
                                                            {entry.description}
                                                            {entry.orderNum ? ` · הזמנה #${entry.orderNum}` : ""}
                                                        </span>
                                                    )}
                                                </div>
                                                <div className={"creditsLogCardLeft"}>
                                                    <span className={`creditsLogCardAmt ${entry.amount >= 0 ? "creditsLogCardAmt--pos" : "creditsLogCardAmt--neg"}`}>
                                                        {entry.amount >= 0 ? "+" : ""}{entry.amount}
                                                    </span>
                                                    <span className={"creditsLogCardBefore"}>יתרה קודמת: {entry.balanceBefore}</span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    {visibleCount < creditsLog.length && (
                                        <button className={"creditsLogShowMore"} onClick={() => setVisibleCount(v => v + 10)}>
                                            הצג עוד ({creditsLog.length - visibleCount} נוספים)
                                        </button>
                                    )}
                                </div>
                            )}
                        </div>
                    }
                />
            )}

            {showCouponsPopup && (
                <PopUpClearComp
                    popFullComp={"specialPopComp onTopOfAll"}
                    cssStyl={"noPadding"}
                    closePop={() => setShowCouponsPopup(false)}
                    insideCss={"noPadding"}
                    theInsideComp={
                        <div className={"couponsPopup"}>
                            <div className={"cardsPopupHeader"}>
                                <span className={"cardsPopupTitle"}>הקופונים שלי</span>
                                <button className={"cardsPopupClose"} onClick={() => setShowCouponsPopup(false)}>✕</button>
                            </div>
                            {visibleCoupons.length === 0 ? (
                                <p className={"cardsPopupEmpty"}>אין קופונים פעילים</p>
                            ) : (
                                <div className={"couponsPopupList"}>
                                    {visibleCoupons.map((k, i) => {
                                        const expired = k.expirationDate && new Date(k.expirationDate) < new Date();
                                        return (
                                            <div key={i} className={`couponCard ${expired ? "couponCard--expired" : "couponCard--active"}`}>
                                                <div className={"couponCardTop"}>
                                                    <span className={"couponCardName"}>{k.koponName || k.koponCode}</span>
                                                    {expired && (
                                                        <span className={"couponCardStatus couponCardStatus--expired"}>פג תוקף</span>
                                                    )}
                                                </div>
                                                {k.buissName && (
                                                    <span className={"couponCardBuis"}>{k.buissName}</span>
                                                )}
                                                {k.koponCode && (
                                                    <div className={"couponCardCode couponCardCode--clickable"} onClick={() => copyKoponCode(k.koponCode)}>
                                                        <h2 className={"couponCardCodeText"}>{k.koponCode}</h2>
                                                        <span className={"couponCardCopyHint"}>
                                                            {copiedKopon === k.koponCode ? "הועתק ✓" : "לחץ להעתקה"}
                                                        </span>
                                                    </div>
                                                )}
                                                <div className={"couponCardMid"}>
                                                    {discountLabel(k) && (
                                                        <span className={"couponCardDiscount"}>{discountLabel(k)}</span>
                                                    )}

                                                </div>
                                                <div className={"couponCardDates onLeft"}>
                                                    {k.expirationDate && !k.isUsed && (
                                                        <span className={"couponCardExpiry"}>בתוקף עד: {formatShortDate(k.expirationDate)}</span>
                                                    )}
                                                    {k.isUsed && k.usedDate && (
                                                        <span className={"couponCardUsedDate"}>נוצל בתאריך: {formatShortDate(k.usedDate)}</span>
                                                    )}
                                                    {k.isUsed && k.orderNum && (
                                                        <span className={"couponCardOrderNum"}>הזמנה #{k.orderNum}</span>
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    }
                />
            )}
        </div>
    );
};

export default MyProfile;
